<template>
  <div>
    <card class="notesCard">
      <div class style>
        <div class="row" style="margin: 0;">
          <div class="flex-grow-1 companyProfileTabulatorTitle">Notes</div>
          <div
            class="d-flex companyProfileCardsAddButton"
            @click="showModal = true;isCreate=true"
            v-if="showAddNotes"
          >
            <div>
              <i class="fa fa-plus" style="font-size: 8px;"></i>
            </div>
            <div>Add</div>
          </div>
        </div>
        <div class="companyProfileTabulatorTitleBorderLine"></div>
      </div>
      <div class="notesCardBodyLayout style-3">
        <div
          class="row mr-0 notesCardBodyParent"
          v-for="(item,index) in notesData"
          :key="index"
          @click="handleEdit(item,index)"
          style="cursor:pointer;"
        >
          <div class="col-12 notesCardBodyNameAndDateColParent">
            <span class="notesCardBodyName">{{item.name}},</span>
            <span
              class="notesCardBodyDate"
            >on {{new Date(item.created).getDate()}} {{monthArray[new Date(item.created).getMonth()]}} {{new Date(item.created).getFullYear()}}</span>
          </div>
          <div class="col-12">
            <div class="notesCardBodyDescriptionPortfolio">{{item.description}}</div>
            <div class="companyProfileTabulatorTitleBorderLine"></div>
          </div>
        </div>
      </div>
    </card>
    <el-dialog
      left
      :title="title"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleCancel()"
      :visible.sync="showModal"
      style="margin: 0 auto;"
      class="todo-modal notes-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="row">
        <div class="col-12 investor-table-wrapper">
          <div class="row">
            <div class="col-12">
              <div>NOTES</div>
              <textarea
                placeholder="Description"
                required="required"
                rows="4"
                cols="50"
                class="form-control"
                v-model="description"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style v-if="showAddNotes">
        <div style="border: 0.8px solid #EDEDED;opacity: 1;"></div>
        <div class="col-xl edit-company-action-button-row" style="padding: 0px;">
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancel"
          >Cancel</button>
          <button
            type="button"
            :disabled="showSpinner"
            @click.prevent="handleSave"
            class="todo-form-submit-button btn btn-primary"
          >
            Save
            <b-spinner v-if="showSpinner" style="float: right;" small label="Loading..."></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option } from "element-ui";
import api from "../../../src/axios_api";
import { mapGetters } from "vuex";
//import { Company, patchCompany } from "../../../models/Company";
//import { vals } from "../../../util";

export default {
  name: "notes-card-spv",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    data: {},
    //portfolioItem: Object
  },
  data() {
    return {
      notesData: [],
      monthArray: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      description: "",
      showModal: false,
      showSpinner: false,
      isCreate: false,
      editedNote: {},
      editedNoteIndex: 0,
    };
  },
  computed: {
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    moment() {
      return moment;
    },
    title() {
      return this.isCreate ? "Add Notes" : "View/Edit Notes";
    },
    showAddNotes() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "ADD NOTES") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
  },
  methods: {
    handleSave() {
      this.showSpinner = true;
      const self = this;
      let userName = self.$store.getters["user/user"];
      let userNameString = `${userName.firstName} ${userName.lastName} `;
      if (this.isCreate) {
        let obj = {};
        obj.name = userNameString;
        obj.entity = "workspace";
        obj.description = this.description;
        api
          .post(`note/${this.$route.params.workspace_id}`, {
            encrypt: {
              data: obj,
            },
          })
          .then((data) => {
            this.notesData.push(data.data.encrypt.success[0]);
            this.$toaster.success("Saved Successfully");
            this.handleCancel();
          })
          .catch((error) => {
            console.log("notes insert error", error);
            this.$toaster.error("Failed to add note");
            this.handleCancel();
          });
      } else {
        let obj = JSON.parse(JSON.stringify(this.editedNote));
        obj.description = this.description;
        api
          .patch("/note", {
            encrypt: {
              data: obj,
            },
          })
          .then((data) => {
            this.notesData[this.editedNoteIndex] = data.data.encrypt.success[0];
            this.$toaster.success("Saved Successfully");
            this.handleCancel();
          })
          .catch((error) => {
            console.log("notes edit error", error);
            this.$toaster.error("Failed to edit note");
            this.handleCancel();
          });
      }
    },
    handleCancel() {
      this.showSpinner = false;
      this.description = "";
      this.showModal = false;
      this.isCreate = false;
    },
    handleEdit(item, index) {
      this.isCreate = false;
      this.showModal = true;
      this.editedNoteIndex = index;
      this.editedNote = item;
      this.description = item.description;
    },
    getNotes() {
      api
        .get(`note/spv/${this.$route.params.workspace_id}`)
        .then((data) => {
          this.notesData = data.data.encrypt.data;
        })
        .catch((err) => console.log(err));
    },
  },
  mounted() {
    this.getNotes();
  },
};
</script>
<style lang="scss">
</style>
